export default "__VITE_ASSET__CbIc33ft__"